export const loadLogEventInDogfoodPerfHUDStoreMiddleware = () =>
  import(/* webpackChunkName: "4-feat-dogfood-perf-hud-middleware" */ './middleware');
